<template>

    <div class="col-md-12 category_panel">
      <div class="categoryPanelTitle">
        <div class="row justify-content-between">
          <div class="col-sm-5 col-md-6 title_box text-center">
            <div class="subtitle_heading" v-if="sectionCount>1">{{categoryIdx+1}} - {{categoryObject.title | translategrader($i18n.locale)}}</div>
            <!-- <div class="current_page">{{categoryIdx+1}}</div> -->
          </div>


          <div class="col-sm-5 col-md-2 align-self-center category_panel_scorebar" v-if="sectionCount>1">
            <div class="progress">
              <div class="progress-bar"
                role="progressbar"
                :style="{ 'width': scorePercent+'%'}"
                :class="{
                  'bg-success': isGood,
                  'bg-warning': isMedium,
                  'bg-error': isBad
                }"
                :aria-valuenow="scorePercent"
                aria-valuemin="0"
                aria-valuemax="100">{{scorePercent}}%
              </div>
            </div>
            <div class="w-100"></div>
            <div class="opinion"
              :class="{
                  'color-success': isGood,
                  'color-warning': isMedium,
                  'color-error': isBad
                }">
              <span v-if="isGood">{{$t('front_end.result_mini_score_good')}}</span>
              <span v-if="isMedium">{{$t('front_end.result_mini_score_medium')}}</span>
              <span v-if="isBad">{{$t('front_end.result_mini_score_bad')}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="categoryEdito">
        <div class="row justify-content-center py-4">
          <div class="col-lg-6" v-if="isGood" v-html="$options.filters.translategrader(categoryObject.results.good, $i18n.locale)"></div>
          <div class="col-lg-6" v-if="isMedium" v-html="$options.filters.translategrader(categoryObject.results.average, $i18n.locale)"></div>
          <div class="col-lg-6" v-if="isBad" v-html="$options.filters.translategrader(categoryObject.results.bad, $i18n.locale)"></div>
        </div>
      </div>
      <div class="categoryBestPractice pb-5">
        <div class="row justify-content-between">
          <div class="col-md-6 col-lg-4" v-for="(question, idx) in categoryObject.questions">
            <answer-card
              :question = "question"
              :index = "idx"
              :questionCount = "categoryObject.questions.length"
              :key = "idx"
            />

          </div>
        </div>
      </div>


    </div>
</template>

<script>

import { mapGetters } from 'vuex'
import answerCard from './survey_lessons/answerCard'

export default {
  name: 'RenderResultSection',

  props: ["categoryObject", "categoryIdx", "score", "sectionCount"],

  components: {
    answerCard
    },

  data () {
    return {
    }
  },

  mounted: function() {
    // console.log("mounted");
    this.$el.style.setProperty('--colorCategory', this.categoryObject.color) ;
  },
  updated: function() {
    // console.log("updated");
    this.$el.style.setProperty('--colorCategory', this.categoryObject.color) ;
  },



  methods: {

  },

  computed: {

      ...mapGetters([
        'surveyCategories'
      ]),

      scorePercent: function() {
        return Math.round(100 * this.score.userScore/this.score.maxScore);
      },

      isGood: function() {
        return (false ||  (this.score.userScore/this.score.maxScore)> 0.66);
      },
      isMedium: function() {
        return (false ||
                (
                 (this.score.userScore/this.score.maxScore)<= 0.66
                 &&
                 (this.score.userScore/this.score.maxScore)>0.33
                )
               );
      },
      isBad: function() {
        return (false ||  (this.score.userScore/this.score.maxScore)<= 0.33);
      },


    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.categoryEdito {
  font-family: 'Nunito', sans-serif;
}

.category_panel {
  background-color: #F3F4F5;
  margin-bottom: 60px;
  border-top: 5px solid var(--colorCategory);
  padding-left: 50px;
  padding-right: 50px;
}

@media print {
  .category_panel {
    page-break-before: always!important;
  }
}


.categoryPanelTitle {
  /* float: left; */
}

.category_panel_scorebar {
  max-width:240px;
}

.title_box {
  position: relative;
}

.title_box .subtitle_heading {
  position: relative;
  text-align: left;
  color: var(--colorCategory);
  font-family: 'Nunito', sans-serif;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 24px;
  margin-top: 15px;
  z-index: 999!important;
}

.title_box .current_page {
  margin-top: -65px;
  margin-bottom: -10px;
  text-align: center;
  color: var(--colorCategory);
  font-family: 'andale mono', sans-serif;
  font-weight: bold;
  text-transform: uppercase;
  font-size: 60px;
  opacity: 0.2;
  z-index: 1!important;
}

.progress {
  border-radius: 8px;
  border: #dbdbdb 1px solid;
  height: 15px;
  background-color: #fff;
}

.bg-success {
  background-color: #139A43!important;
}
.bg-warning {
  background-color: #FC8F00!important;
}
.bg-error {
  background-color: #DC0000!important;
}

.color-success {
  color: #139A43!important;
}
.color-warning {
  color: #FC8F00!important;
}
.color-error {
  color: #DC0000!important;
}
.opinion {
  font-family: 'Nunito', sans-serif;
  font-size: 12px;
  text-align: center;
}

@media only screen and (max-width: 575px) {
  .category_panel_scorebar {
    max-width: none;
  }

  .category_panel_scorebar .opinion {
    font-size: 15px;
    font-weight: stronger;
    padding-bottom: 15px;
    padding-top: 5px;
  }

  .progress {
    border-radius: 10px;
    height: 20px;
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/RenderResultSection.vue